import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { Link } from 'react-router-dom';
import logo from "../../../Assets/securent 2.svg";
import profileIcon from "../../../Assets/Vector.svg";
import Profils from "./Profile";
import { NavLink } from "react-router-dom";
import API_BASE_URL from '../../ApiConfig/ApiConfig';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const fetchUserDetails = async () => {
      const token = Cookies.get('token');
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const customerId = decodedToken.customerId;
          const role = decodedToken.role;
          setUserRole(role);
          console.log("user role", role)

          const response = await fetch(`${API_BASE_URL}/api/users/customer/${customerId}`,
            { headers: { 
                "Content-Type": "application/json",
                "Authorization": token ? `Bearer ${token}` : "",
            } });
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
          }
          const data = await response.json();
          setUserName(data.name);
        } catch (error) {
          setError(`Error fetching user details: ${error.message}`);
        } finally {
          setLoading(false);
        }
      } else {
        setError('No token found in Cookies.');
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  const handleProfileClick = () => {
    setIsModalOpen(true);
  };

  const closeMobileMenu = () =>  {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 w-full text-white shadow-lg z-40" style={{ backgroundColor: "#1C50A3" }}>
      <div className="container max-w-screen-xl mx-auto px-4 py-3 sm:py-4">
        <div className="flex justify-between items-center">
          {/* Mobile Menu Toggle Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-white focus:outline-none p-1"
            aria-label="Toggle mobile menu"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          {/* Logo */}
          <Link to="/customer_dashboard" className="flex items-center flex-shrink-0 mx-auto lg:mx-0">
            <img src={logo} alt="Secure Net Logo" className="h-6 sm:h-7 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex flex-grow justify-center space-x-4 xl:space-x-6 2xl:space-x-8 max-w-4xl mx-8">
            <NavLink
              to="/customer_dashboard/registered_product"
              className={({ isActive }) =>
                `font-medium cursor-pointer text-xs xl:text-sm px-3 py-2 rounded-md hover:text-white transition-colors duration-200 whitespace-nowrap ${
                  isActive ? "text-white border-b-2 border-white" : "text-[#D1D1D1]"
                }`
              }
            >
              Product Register
            </NavLink>
            <NavLink
              to="/customer_dashboard/registered_product_details"
              className={({ isActive }) =>
                `font-medium cursor-pointer text-xs xl:text-sm px-3 py-2 rounded-md hover:text-white transition-colors duration-200 whitespace-nowrap ${
                  isActive ? "text-white border-b-2 border-white" : "text-[#D1D1D1]"
                }`
              }
            >
              Product Repair
            </NavLink>
            <NavLink
              to="/customer_dashboard/awr/records"
              className={({ isActive }) =>
                `font-medium cursor-pointer text-xs xl:text-sm px-3 py-2 rounded-md hover:text-white transition-colors duration-200 whitespace-nowrap ${
                  isActive ? "text-white border-b-2 border-white" : "text-[#D1D1D1]"
                }`
              }
            >
              AWR
            </NavLink>
            {userRole !== "User" && (
              <>
                <NavLink
                  to="/customer_dashboard/scheme"
                  className={({ isActive }) =>
                    `font-medium cursor-pointer text-xs xl:text-sm px-3 py-2 rounded-md hover:text-white transition-colors duration-200 whitespace-nowrap ${
                      isActive ? "text-white border-b-2 border-white" : "text-[#D1D1D1]"
                    }`
                  }
                >
                  Scheme
                </NavLink>
                <NavLink
                  to="/customer_dashboard/SchemeStatus"
                  className={({ isActive }) =>
                    `font-medium cursor-pointer text-xs xl:text-sm px-3 py-2 rounded-md hover:text-white transition-colors duration-200 whitespace-nowrap ${
                      isActive ? "text-white border-b-2 border-white" : "text-[#D1D1D1]"
                    }`
                  }
                >
                  Scheme Status
                </NavLink>
              </>
            )}
            <NavLink
              to="/customer_dashboard/agreement-form"
              className={({ isActive }) =>
                `font-medium cursor-pointer text-xs xl:text-sm px-3 py-2 rounded-md hover:text-white transition-colors duration-200 whitespace-nowrap ${
                  isActive ? "text-white border-b-2 border-white" : "text-[#D1D1D1]"
                }`
              }
            >
              Agreement
            </NavLink>
          </div>

          {/* Profile Icon */}
          <div className="flex items-center cursor-pointer flex-shrink-0" onClick={handleProfileClick}>
            <img src={profileIcon} alt="Profile" className="h-7 w-7 sm:h-8 sm:w-8 rounded-full border-2 border-white" />
            <div className="hidden lg:flex ml-2 items-center">
              {loading ? (
                <span className="text-white font-medium text-sm">Loading...</span>
              ) : error ? (
                <span className="text-white font-medium text-xs">Error</span>
              ) : (
                <span className="text-white font-medium text-sm truncate max-w-24 xl:max-w-32">{userName}</span>
              )}
              <svg className="w-4 h-4 text-white ml-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-95 backdrop-blur-sm z-50 lg:hidden">
          <div className="flex flex-col h-full">
            {/* Mobile Menu Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-700">
              <div className="text-lg font-bold text-white">SECURENET</div>
              <button 
                onClick={() => setMobileMenuOpen(false)} 
                className="text-white focus:outline-none p-1"
                aria-label="Close mobile menu"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Mobile Menu Content */}
            <div className="flex-1 overflow-y-auto">
              <div className="px-4 py-6 space-y-4">
                <Link
                  to="/customer_dashboard/registered_product"
                  onClick={closeMobileMenu}
                  className="block text-white font-medium hover:bg-[#3159a6] transition-colors duration-200 text-base py-3 px-4 rounded-md"
                >
                  Product Register
                </Link>
                <Link
                  to="/customer_dashboard/registered_product_details"
                  onClick={closeMobileMenu}
                  className="block text-white font-medium hover:bg-[#3159a6] transition-colors duration-200 text-base py-3 px-4 rounded-md"
                >
                  Product Repair
                </Link>
                <Link
                  to="/customer_dashboard/awr/records"
                  onClick={closeMobileMenu}
                  className="block text-white font-medium hover:bg-[#3159a6] transition-colors duration-200 text-base py-3 px-4 rounded-md"
                >
                  AWR
                </Link>
                {userRole !== "User" && (
                  <>
                    <Link
                      to="/customer_dashboard/scheme"
                      onClick={closeMobileMenu}
                      className="block text-white font-medium hover:bg-[#3159a6] transition-colors duration-200 text-base py-3 px-4 rounded-md"
                    >
                      Scheme
                    </Link>
                    <Link
                      to="/customer_dashboard/SchemeStatus"
                      onClick={closeMobileMenu}
                      className="block text-white font-medium hover:bg-[#3159a6] transition-colors duration-200 text-base py-3 px-4 rounded-md"
                    >
                      Scheme Status
                    </Link>
                  </>
                )}
                <Link
                  to="/customer_dashboard/agreement-form"
                  onClick={closeMobileMenu}
                  className="block text-white font-medium hover:bg-[#3159a6] transition-colors duration-200 text-base py-3 px-4 rounded-md"
                >
                  Agreement
                </Link>
              </div>

              {/* Mobile User Info */}
              <div className="border-t border-gray-700 p-4 mt-auto">
                <div className="flex items-center">
                  <img src={profileIcon} alt="Profile" className="h-8 w-8 rounded-full border-2 border-white" />
                  <div className="ml-3">
                    {loading ? (
                      <span className="text-white font-medium text-sm">Loading...</span>
                    ) : error ? (
                      <span className="text-white font-medium text-sm">Error loading user</span>
                    ) : (
                      <span className="text-white font-medium text-sm">{userName}</span>
                    )}
                    <div className="text-xs text-gray-300">{userRole}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Profile Modal */}
      {isModalOpen && <Profils onClose={() => setIsModalOpen(false)} />}
    </nav>
  );
};

export default Navbar;
